import { Component, OnInit } from '@angular/core';
import { CustomerBankAccountSetupService } from 'src/app/services/customer-bank-account-setup.service';

@Component({
  selector: 'app-customer-bank-account-setup',
  templateUrl: './customer-bank-account-setup.component.html',
  styleUrls: ['./customer-bank-account-setup.component.css']
})
export class CustomerBankAccountSetupComponent implements OnInit {

  constructor(public customerBankAccountSetup: CustomerBankAccountSetupService) { }

  ngOnInit(): void {
  
  }
  onSubmit()
  {
    //console.log(this.customerBankAccountSetup.customerBankAccountSetupForm.value);
  }


}
